import { CallCenterSettingsBuilder } from "./call-center-settings.builder";
var CallCenterSettingsLocaleMapBuilder = /** @class */ (function () {
    function CallCenterSettingsLocaleMapBuilder() {
        var _a;
        this.callCenterSettings = (_a = {},
            _a['en'] = new CallCenterSettingsBuilder().build(),
            _a['fr'] = new CallCenterSettingsBuilder().build(),
            _a);
    }
    CallCenterSettingsLocaleMapBuilder.prototype.withCallCenterSettings = function (locale, settings) {
        this.callCenterSettings[locale] = settings;
        return this;
    };
    CallCenterSettingsLocaleMapBuilder.prototype.build = function () {
        return this.callCenterSettings;
    };
    return CallCenterSettingsLocaleMapBuilder;
}());
export { CallCenterSettingsLocaleMapBuilder };
//# sourceMappingURL=call-center-settings-locale-map-builder.js.map